import { Grid, Typography } from '@mui/material';
import React from 'react';
import { injectIntl } from 'react-intl';
import SelectButtonGroup from '../../../../components/SelectButtonGroup/SelectButtonGroup';

const AccountTypesInput = props => {
  const { intl, value, onChange } = props;

  return (
    <Grid
      container
      spacing={2}
      wrap="nowrap"
      sx={{
        justifyContent: "space-between",
        alignItems: "flex-start"
      }}>
      <Grid>
        <Typography color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
          {intl.formatMessage({ id: 'account-types' })}
        </Typography>
      </Grid>
      <Grid>
        <SelectButtonGroup
          value={value}
          choices={['personal', 'voluntary', 'contribution', 'provident-fund'].map(choice => ({
            value: choice,
            label: intl.formatMessage({ id: `at-${choice}` })
          }))}
          onChange={onChange}
          sx={{ justifyContent: "flex-end" }}
          buttonClassName="plan-type-select-button"
          multi={true}
        />
      </Grid>
    </Grid>
  );
};

export default injectIntl(AccountTypesInput);
